var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLButtonModal",
    _vm._g(
      _vm._b(
        {
          ref: "modal",
          attrs: {
            color: "orange",
            okBtnAction: "yes",
            title: _vm.$t("tenancy.greenOperation.tips.confirmSubmit"),
          },
        },
        "HKLButtonModal",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }